import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { PracticeService } from 'src/app/services/practice.service';
import { Practice } from 'src/app/models/practice';
import {TimeZoneService} from "../../services/timezone.service";

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  public practice: Practice = new Practice();
  public loadingPractice: boolean = true;
  public image:string='/assets/imgs/pricing-image.jpg';

  public title:string='Certified CPD at incredible prices';
  public titleAuckland:string='New Zealand Veterinary Association Accredited CPD covering a wide range of topics';
  public titleIreland:string='Certified CPD at Incredible Prices';
  public titleUsaCanada:string='Top CE at Incredible Prices';


  public blurb:string='Currently over 2,000 CPD videos available to view with more videos added every week.';
  public blurbIreland:string='Currently over 2,000 CPD videos available to view with more videos added every week.';


  public loggedIn:boolean=false;
  public loadingSubscriptions: boolean = true;
  public hasPracticeSubscription:boolean = false;
  public currentType:number=1;
  // TimeZone related configuration
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;
  public AustraliaTimeZone:boolean = false;
  public AucklandTimeZone:boolean = false;
  public HongKongTimeZone:boolean = false;
  public EUTimeZone:boolean = false;
  public CanadaTimeZone:boolean = false;
  public UAETimeZone:boolean = false;

  constructor(
    private practiceService: PracticeService,
    private subscriptionService: SubscriptionService,
    private timezoneService: TimeZoneService
  ) {
    if (localStorage.getItem('token')) this.loggedIn=true;
  }

  ngOnInit() {
    // TimeZone Configuration
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.AustraliaTimeZone = this.timezoneService.checkAustraliaTimeZone();
    this.AucklandTimeZone = this.timezoneService.checkAucklandTimeZone();
    this.HongKongTimeZone = this.timezoneService.checkHongKongTimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();
    this.UAETimeZone = this.timezoneService.checkUAETimeZone();

    if(this.loggedIn){
      this.getMyPractice();
      this.getMySubscription();
    }
  }

  getMySubscription(){
    // console.log(new Date().getTime());
    this.subscriptionService.getUserSubscriptions().subscribe(res=>{
      res.forEach(sub=>{
        // console.log(new Date(sub.sub_until).getTime())
        if((sub.plan.stripe_reference=='monthly_practice' || sub.plan.stripe_reference=='annual_practice') && (sub.status == 'active' || new Date(sub.sub_until).getTime() > new Date().getTime())){
            this.hasPracticeSubscription = true;
        }
      })
      this.loadingSubscriptions=false;
    })
  }

  getMyPractice(){
    this.practiceService.getMyPractice().subscribe(practice=>{
      this.practice = practice;
      this.loadingPractice = false;
    },err=>{
      this.loadingPractice = false;
    })
  }
}

